import { createFileRoute } from '@tanstack/react-router';
import { useAdminAuthGuard } from '@/features/admin/hooks';
import { VaultUploadsPanel } from '@/features/admin/VaultUploadsPanel';
import { AdminShell } from '@/features/admin/components/AdminShell';
import { AdminPageHeader } from '@/features/admin/components/AdminPageHeader';
import { AdminLogoutButton } from '@/features/admin/components/AdminLogoutButton';

/**
 * Admin Vault Uploads route — the platform operator's view of documents uploaded by
 * training-track companies, across all tenants, each promotable into a product's
 * supporting documents (Track B data collection). Bounces to /admin/login if the
 * admin cookie isn't set.
 */
export const Route = createFileRoute('/admin/vault-uploads')({
  component: AdminVaultUploadsPage,
});

function AdminVaultUploadsPage() {
  useAdminAuthGuard();
  return (
    <AdminShell actions={<AdminLogoutButton />}>
      <AdminPageHeader
        title="Vault Uploads"
        subtitle="Documents uploaded by companies across all tenants — AI-training and Non-AI alike. Promote a file into one of that company's products as a supporting document."
      />
      <VaultUploadsPanel />
    </AdminShell>
  );
}
